import axios from 'axios'
import { put, call, take, fork } from 'redux-saga/effects'
import { routerActions } from 'react-router-redux'

import { ACCESS_TOKEN, NAME } from '../../commons/Const'
import { CREATE_USER, CREATE_USER_SUCCESS, CREATE_USER_FAILURE } from '../actions/authActions'
import { buildJoinQueryString, setStorage } from '../../commons/utils'
import { SHOW_ERROR_POPUP } from '../actions/noticeActions'

export function* runCreateParticipantHandler() {
  while (true) {
    const { payload } = yield take([`${CREATE_USER}`])
    yield fork(createParticipantHandler, payload)
  }
}

function* createParticipantHandler(payload) {
  const { data, error } = yield call(createParticipant, payload)
  if (error != null) {
    yield put(CREATE_USER_FAILURE())
    yield put(SHOW_ERROR_POPUP(error.message))
    return
  }
  yield put(routerActions.push(`/quiz?${buildJoinQueryString(payload)}`))
  yield put(CREATE_USER_SUCCESS(data))
}

const createParticipant = ({ share_param, name }) => {
  const params = {
    name,
    shareParam: share_param
  }
  return axios
    .post('/api/v1/participants/auth', params)
    .then(response => {
      const ONE_DAY = 60 * 60 * 24
      setStorage(ACCESS_TOKEN, response.data.data.access_token, ONE_DAY)
      setStorage(NAME, response.data.data.name, ONE_DAY)
      return { data: response.data }
    })
    .catch(error => {
      return { error: error.response.data }
    })
}
